import React, { useEffect } from 'react';
import { Form, useFormikContext } from 'formik';

import { Label } from 'core';
import { FormField } from 'core/components/form';
import { Card } from 'core/components/card';
import useStyles from './signed-documents-required-section.styles';
import { useToast } from 'core/components/toast';
import CoverageChange from './coverage-change';
import PropTypes from 'prop-types';

const SignedDocumentsRequiredSection = ({ preview }) => {
  const classes = useStyles();
  const toast = useToast();
  const { errors, touched } = useFormikContext();

  useEffect(() => {
    if (errors.signedDocumentsRequiredCheckbox && touched.signedDocumentsRequiredCheckbox) {
      toast.notify({
        type: 'error',
        message: 'You must complete all required changes before saving.'
      });
    }
  }, [errors, touched, toast]);

  return (
    <Card type="primary" className={classes.container}>
      <Label type="darkGreenSmallBold">Signed documents are required for this change.</Label>
      <p>One or more member-signed documents are needed for the following coverage change(s).</p>
      {preview.trailingDocChanges.map((trailingDocChange, index) => (
        <CoverageChange trailingDocChange={trailingDocChange} key={index} preview={preview} />
      ))}
      <Form>
        <FormField
          mode="light"
          label="I attest to having the required document(s) signed by the member, retained within the agency, and available upon request from Branch."
          type="checkbox"
          id="signedDocumentsRequiredCheckbox"
          name="signedDocumentsRequiredCheckbox"
          ignoreGlobalDisabledState
        />
      </Form>
    </Card>
  );
};

SignedDocumentsRequiredSection.propTypes = {
  preview: PropTypes.shape({
    trailingDocChanges: PropTypes.array
  })
};

export default SignedDocumentsRequiredSection;
